import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { v5 as uuidv5 } from "uuid";
import { URL_PARAMS } from "../../constants";

// Returns a deterministic UUID derived from the attrs param when useAttrsAsSession=1,
// so the same attribute combination always maps to the same session.
export function useAttrsSessionId(): string | null {
  const { search } = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(search);
    if (params.get(URL_PARAMS.USE_ATTRS_AS_SESSION) !== "1") return null;
    const attrsParam = params.get(URL_PARAMS.ATTRS);
    return attrsParam ? uuidv5(attrsParam, uuidv5.URL) : null;
  }, [search]);
}
